import * as React from 'react';
import { FontAwesomeIcon } from './helpers/FontAwesomeIcon'
import { faCalendar } from '@fortawesome/free-solid-svg-icons'

export const ScheduleIcon = (props: { color: string }) => {
  return (
    <FontAwesomeIcon icon={faCalendar} color={props.color} />
  )
}
